import React from 'react';
import '../TermsAndConditions/TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <header className="terms-header">
          <h1>Terms and Conditions</h1>
          <p>Your booking agreement — please review carefully before confirming your flight reservation</p>
        </header>

        <div className="terms-body">
          <p>
            These booking terms and conditions govern all flight reservations that you make with Click4Flight. Please read them carefully as they establish our respective rights and obligations. In these booking conditions, references to "we", "us", and "our" indicate Click4Flight, and references to "you" and "your" include the primary passenger named on the booking and all persons on whose behalf a booking is made or any other person to whom a booking is added or transferred. Your use of this website is expressly conditioned on your acceptance of the following terms and conditions. If you do not agree with any part of these terms and conditions, you must not use this site or confirm any flight booking with us.
          </p>
          <p>
            With Click4Flight, you can book comprehensive flight arrangements—whether that's individual flights, multi-sector itineraries, or flight-inclusive packages. We specialize in securing competitive airfares and managing your flight reservations efficiently.
          </p>

          <div className="terms-section">
            <h2>Section A - Applicable for all flight bookings</h2>
            
            <div className="booking-section">
              <h3>Booking Your Flight Arrangements</h3>
              <p>
                By making a flight booking, the primary passenger/lead passenger on the booking or the person making the reservation agrees on behalf of all persons detailed on the booking that he/she:
              </p>
              <ol>
                <li>has read these Booking Conditions and agrees to be bound by them;</li>
                <li>consents to our use of personal data in accordance with our Privacy Policy and is authorised on behalf of all persons named on the booking to disclose their personal details to us, including where applicable, special categories of data (such as information on health conditions or disabilities and specific travel requirements);</li>
                <li>is over 18 years of age at the time of booking and where placing an order for flight services with age restrictions declares that he/she and all members of the party are of the appropriate age to purchase those services; and</li>
                <li>accepts financial responsibility for payment of the booking on behalf of all persons detailed on the booking.</li>
              </ol>
            </div>

            <div className="terms-subsection">
              <h3>Flight Availability and Payment Requirements</h3>
              <p>
                All flight services offered are subject to airline availability and seat inventory. Airfares are not guaranteed until they are ticketed and confirmed by the airline. When you make your booking you must pay the relevant deposit or full payment as specified at the time of booking. No contract will come into existence until we accept your booking, receive your payment in cleared funds, and issue you with a confirmation invoice or e-ticket. Please ensure that passenger names match exactly as they appear on the relevant passport or travel document.
              </p>
              <p>
                <strong>Telephone bookings:</strong> If you make a booking by telephone, you must provide us with all required information accurately. Passenger information must match passport details exactly. You must also ensure that the credit or debit card you are using is your own or, subject to our acceptance, if it belongs to a third party, you have their express authorisation to use it and that sufficient funds are available. Please note that a telephone booking confirmation is as firmly confirmed as if made in writing. We do not guarantee flight availability until payment is received and confirmed. If we accept your booking, we will process it (subject to availability) and debit payment. From this point, cancellation charges will apply. We will send you confirmation and/or e-tickets. Upon receipt, please check all details carefully and inform us immediately of any errors as changes may not be possible later. Any modifications after booking confirmation will incur additional charges, including airline fees and our administration fees.
              </p>
              <p>
                <strong>Payments:</strong> You must pay any balance by the due date shown on your confirmation invoice. For many telephone bookings, full payment may be required immediately—before you receive formal confirmation. If this applies, you will be advised when booking. Timely payment of balances is crucial; failure may result in cancellation of your flights while still incurring cancellation charges. Where booking fees apply, these will be advised at booking. All payments require clearance time as per our payment policy. Until full payment is received, your fare may increase due to airline-imposed fuel surcharges or other charges. We do not accept responsibility for cash sent by courier or post, even if sent by registered or recorded delivery.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Passport, Visa & Health Requirements</h3>
              <p>
                Recommended inoculations and health precautions for travel may change, and you should consult your healthcare provider for current recommendations well before departure. The Foreign and Commonwealth Office (FCO) advises visiting your health professional 4 to 6 weeks before travel. Country-specific information is available on the TravelHealthPro website and NHS websites. It is your responsibility to ensure you obtain recommended inoculations, take necessary medications, and follow all medical advice for your journey.
              </p>
              <p>
                We do not accept responsibility if you cannot travel or incur losses due to non-compliance with passport, visa, immigration, or health requirements. You agree to reimburse us for any fines or losses we incur resulting from your failure to meet these requirements.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Special Requests and Medical Conditions</h3>
              <p>
                If you have any special requests (e.g., dietary requirements, seating preferences), please advise us at time of booking. While we will endeavour to pass requests to the airline, we cannot guarantee they will be fulfilled. Failure to meet special requests does not constitute a breach of contract. If you have medical conditions or disabilities that may affect your travel, you must advise us in writing before booking with full details. Many airlines and destinations have limited facilities for passengers with specific needs. If we cannot properly accommodate your requirements, we reserve the right to decline or cancel your booking, applying any applicable cancellation charges.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Passenger Behaviour</h3>
              <p>
                You accept responsibility for ensuring that you and your party behave appropriately and do not cause offence, damage, or loss to others or property. Payments for any damage or loss must be made directly to the airline or relevant supplier at the time. You indemnify us against any claims (including legal costs) made against us due to your actions. We expect all passengers to show consideration for others. If, in our reasonable opinion or that of any authority, your behaviour causes or is likely to cause distress, danger, annoyance, or damage, we reserve the right to terminate your arrangements without notice. In such cases, your entire booking, including return flights, will cease immediately, and we will not be responsible for any costs, expenses, refunds, or compensation.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Flight Information</h3>
              <h4>Flight Cancellations & Schedule Changes</h4>
              <p>
                If your flight is cancelled, your rights are governed by the airline's conditions of carriage. You may be entitled to: (a) rebooking on another flight with the same airline without additional cost; (b) rerouting with another carrier without additional cost; (c) a full refund; or (d) other remedies as per airline policy.
              </p>
              <p>
                If a schedule change occurs before we receive full payment or before ticket issuance, we will endeavour to notify you on behalf of the airline.
              </p>
              <p>
                Schedule changes after full payment/ticket issuance are subject to the airline's final decision, and amendment charges may apply.
              </p>
              <p>
                Most discounted airline tickets carry 100% cancellation charges. Please verify charges applicable to your ticket at booking.
              </p>
              
              <h4>Airline Ticket Refunds</h4>
              <p>
                You will be subject to per-ticket cancellation charges imposed by the airline or consolidator according to their terms. Air ticket refunds also incur a £50 per ticket administration fee, regardless of the number of tickets. There is no automatic right to a refund; we will forward cancellation requests to the relevant airline/consolidator for assessment per their terms.
              </p>
              <p>
                If a recoverable refund is less than the administration fee, the ticket will be deemed non-refundable. The fee applies even to non-refundable tickets where tax refund applications are made at your request. If recoverable taxes are less than the fee, the ticket is fully non-refundable. Refunds will be processed only after we receive them from the airline/consolidator, typically 4-6 weeks after submission.
              </p>
              
              <h4>E-Tickets</h4>
              <p>
                Many airlines issue electronic tickets (e-tickets) only. If you require a paper ticket where permitted, a £10 per ticket administration fee applies, plus any airline charges.
              </p>
              
              <h4>Flight Operations</h4>
              <p>
                Note that "direct" flights may involve stops. All departure/arrival times are airline estimates and may change due to air traffic control, weather, operational needs, or check-in requirements. Click4Flight will advise of known schedule changes, but you are strongly advised to reconfirm flights with the airline 72 hours before departure. We cannot arrange special accommodations for delays; such matters are at the airline's discretion.
              </p>
              
              <h4>Airport Taxes and Fees</h4>
              <p>
                Not all taxes and fees are included in your ticket price. Some local departure taxes must be paid directly to the airport authorities and are non-refundable by us.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Travel Insurance</h3>
              <p>
                Adequate travel insurance is a condition of your booking with us or the airline/supplier. You may purchase insurance through us or independently. Coverage must include cancellation charges, trip curtailment, medical and repatriation expenses (including air ambulance), personal accident, and loss/damage to personal effects.
              </p>
              <p>
                If you choose to travel without adequate insurance, we will not be liable for losses that would have been covered by insurance.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Booking Conditions for Flight Packages</h3>
              <h4>Flight-Inclusive Packages</h4>
              <p>
                A flight package includes at least two of the following: a) flights b) accommodation c) another significant tourist service, sold together at an inclusive price with full payment to Click4Flight.
              </p>
              <p>
                Where your booking constitutes a Multi-Contract Package under the Package Travel and Linked Travel Arrangements Regulations 2018, we act as "Package Organiser," and you receive associated rights and benefits.
              </p>
              <p>
                A "Multi-Contract Package" exists if you book at least two different types of travel services for the same trip:
              </p>
              <ul>
                <li>transport (flights); or</li>
                <li>accommodation; or</li>
                <li>car/motor vehicle rental (in certain cases); and</li>
                <li>any other tourist service not intrinsically part of the above, provided services are purchased together, selected before payment, advertised/sold at an inclusive price, or marketed as a "package."</li>
              </ul>
              <p>
                This is a Multi-Contract Package where you have contracts with individual suppliers, but Click4Flight accepts responsibility as Package Organiser.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Alterations and Cancellations</h3>
              <h4>Changes by You</h4>
              <p>
                If you wish to modify your booking after confirmation, we will endeavour to assist. You must confirm changes in writing and pay a £50 per person amendment fee, plus any costs we incur, including airline/supplier charges. Note that many discounted fares are non-changeable, and alteration requests may incur up to 100% cancellation charges.
              </p>
              
              <h4>Cancellation by You</h4>
              <p>
                You may cancel your booking at any time by written notice from the person who made the booking. As we incur costs upon cancellation, we will retain deposits, and additional charges may apply. If cancellation reasons are covered by insurance, you may reclaim charges.
              </p>
              
              <table className="cancellation-table">
                <thead>
                  <tr>
                    <th>Period before departure within which cancellation notice is received</th>
                    <th>Cancellation charge</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>More than 56 days</td>
                    <td>Deposit only</td>
                  </tr>
                  <tr>
                    <td>Between 28 and 56 days</td>
                    <td>60% of total cost</td>
                  </tr>
                  <tr>
                    <td>Between 7 and 27 days</td>
                    <td>90% of total cost</td>
                  </tr>
                  <tr>
                    <td>Less than 7 days</td>
                    <td>100% of total cost</td>
                  </tr>
                </tbody>
              </table>
              
              <p>
                Note: Insurance premiums and amendment charges are non-refundable.
              </p>
              <p>
                Some flight arrangements cannot be changed or cancelled without 100% charges; we will inform you if this applies before cancellation.
              </p>
              <p>
                We strongly recommend comprehensive travel insurance covering cancellation fees.
              </p>
              <p>
                Cancellation charges will be deducted from payments already made.
              </p>
              <p>
                Most discounted tickets carry 100% cancellation charges; verify at booking.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Complaints Procedure</h3>
              <p>
                Where we act as agent, your contract is with the airline/supplier, and queries should be directed to them. If problems arise during travel, report them to the airline or their local representative immediately. Failure to do so may limit resolution opportunities and affect compensation eligibility.
              </p>
              <p>
                If the supplier cannot resolve issues satisfactorily at the time, contact us immediately at 020 3355 7350  or info@click4flight.co.uk so we can assist. If complaints remain unresolved, you must write to us within 28 days of return, quoting your booking reference. Failure to follow these steps may hinder investigation and reduce or extinguish compensation rights.
              </p>
            </div>

            <div className="terms-subsection">
              <h3>Jurisdiction and Governing Law</h3>
              <p>
                These Booking Conditions and any related agreements are governed by English law. Both parties agree that disputes, claims, or matters arising from your contract or booking will be dealt with exclusively by the Courts of England and Wales. You may choose the law and jurisdiction of Scotland or Northern Ireland if you reside there and wish to do so.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;